// extracted by mini-css-extract-plugin
export var label = "_f2-2";
export var slideContainer = "_f2-0";
export var slider = "_f2-1";